import { ApiPath } from 'src/enums/apiPath';
import { customerApiRequest } from 'src/utils/api';

export const customerGetImeiList = async (params?: { [key: string]: any }) => {
  const res = await customerApiRequest.get({
    url: ApiPath.CUSTOMER_IMEI,
    params: params
  });

  return res.data;
};

export const customerGetImeiDetail = async (id: string) => {
  const res = await customerApiRequest.get({
    url: ApiPath.CUSTOMER_IMEI_DETAIL + `/${id}`
  });

  return res.data;
};

export const customerConfirmImei = async (id: string | number, data: any) => {
  const res = await customerApiRequest.put({
    url: ApiPath.CUSTOMER_IMEI_DETAIL + `/${id}`,
    data,
    headers: { 'Content-Type': 'multipart/form-data', 'accept-language': 'ja' }
  });

  return res.data;
};

export const getNotReadImeiCount = async () => {
  const res = await customerApiRequest.get({
    url: ApiPath.CUSTOMER_NOT_READ_IMEI_COUNT
  });

  return res.data;
};
